module.exports = __webpack_public_path__ + "img/expand.557a4adc.png";